import React, { Component } from 'react';
import { ArrowLeft, Phone, MessageSquare, Calendar, Package, User, Building2, Clock, Search, FileText, Loader, ChevronDown, ChevronLeft, ChevronRight, Truck } from 'lucide-react';
import axios from 'axios';
import Cookies from "universal-cookie";
import moment from 'moment-timezone';
import host from "./host";

const cookies = new Cookies();

class OrderDetailsPage extends Component {
    constructor(props) {
        super(props);
        
        // تعيين تاريخ اليوم كقيمة افتراضية
        const today = new Date();
        const todayFormatted = today.getFullYear() + '-' + 
            String(today.getMonth() + 1).padStart(2, '0') + '-' + 
            String(today.getDate()).padStart(2, '0');
        
        this.state = {
            searchTerm: '',
            searchDate: todayFormatted,
            showModal: false,
            selectedStatus: '',
            postponeDate: '',
            orders: [],
            filteredOrders: [],
            loading: true,
            error: null,
            currentStatus: 'مؤجل',
            selectedOrderId: null,
            // إضافة حالات جديدة للفلتر
            selectedDelayedDate: 'all',
            showDateFilter: false,
            // إضافة حالات Pagination
            currentPage: 1,
            itemsPerPage: 10,
            totalOrders: 0,
            availableDates: [],
            isSearching: false
        };
        
        // Debounce timer للبحث
        this.searchTimer = null;
    }

    componentDidMount() {
        const todayFormatted = this.formatDateForAPI(this.state.searchDate);
        this.fetchOrders('مؤجل', todayFormatted, 1, '', 'all');
    }

    componentWillUnmount() {
        // تنظيف timers عند إلغاء المكون
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
    }

    // جلب الطلبات من API مع Pagination
    fetchOrders = async (status = 'مؤجل', delay = '', page = 1, searchTerm = '', delayedDateFilter = '') => {
        try {
            // إظهار حالة البحث إذا كان هناك بحث أو فلتر
            const isFiltering = searchTerm || (delayedDateFilter && delayedDateFilter !== 'all');
            this.setState({ 
                loading: !isFiltering, 
                isSearching: isFiltering,
                error: null 
            });

            const encodedStatus = encodeURIComponent(status);
            const skip = (page - 1) * this.state.itemsPerPage;
            let url = `${host}users/majel_mtab3a-orders?status=${encodedStatus}&skip=${skip}&take=${this.state.itemsPerPage}`;
            
            if (delay) {
                url += `&deley=${encodeURIComponent(delay)}`;
            }

            // إضافة معاملات البحث والفلتر
            if (searchTerm && searchTerm.trim() !== '') {
                url += `&search=${encodeURIComponent(searchTerm)}`;
            }

            if (delayedDateFilter && delayedDateFilter !== 'all') {
                url += `&delayedDate=${encodeURIComponent(delayedDateFilter)}`;
            }

            const response = await axios.get(url);

            this.setState({
                orders: response.data.orders || [],
                filteredOrders: response.data.orders || [],
                totalOrders: response.data.total || 0,
                availableDates: response.data.availableDates || [],
                loading: false,
                isSearching: false,
                currentStatus: status,
                currentPage: page
            });
        } catch (error) {
            console.error('Error fetching orders:', error);
            this.setState({
                error: 'حدث خطأ في جلب البيانات',
                loading: false,
                isSearching: false
            });
        }
    };

    // دالة تحويل التاريخ إلى صيغة "منذ" محسنة
    getRelativeTime = (dateString) => {
        try {
            const date = moment(dateString).tz('Asia/Baghdad');
            const now = moment().tz('Asia/Baghdad');
            
            const diffMinutes = now.diff(date, 'minutes');
            const diffHours = now.diff(date, 'hours');
            const diffDays = now.diff(date, 'days');
            const diffWeeks = now.diff(date, 'weeks');
            const diffMonths = now.diff(date, 'months');
            
            let timeText = '';
            let color = '#059669'; // أخضر للأوقات القريبة
            let bgColor = '#d1fae5';
            let icon = '🟢';
            
            if (diffMinutes < 1) {
                timeText = 'الآن';
                icon = '⚡';
                color = '#059669';
                bgColor = '#d1fae5';
            } else if (diffMinutes < 60) {
                timeText = `منذ ${diffMinutes} ${diffMinutes === 1 ? 'دقيقة' : diffMinutes < 11 ? 'دقائق' : 'دقيقة'}`;
                icon = '🟢';
                color = '#059669';
                bgColor = '#d1fae5';
            } else if (diffHours < 24) {
                timeText = `منذ ${diffHours} ${diffHours === 1 ? 'ساعة' : diffHours < 11 ? 'ساعات' : 'ساعة'}`;
                if (diffHours < 6) {
                    icon = '🟡';
                    color = '#d97706';
                    bgColor = '#fed7aa';
                } else {
                    icon = '🟠';
                    color = '#ea580c';
                    bgColor = '#ffedd5';
                }
            } else if (diffDays < 7) {
                timeText = `منذ ${diffDays} ${diffDays === 1 ? 'يوم' : diffDays < 11 ? 'أيام' : 'يوم'}`;
                icon = '🔴';
                color = '#dc2626';
                bgColor = '#fee2e2';
            } else if (diffWeeks < 4) {
                timeText = `منذ ${diffWeeks} ${diffWeeks === 1 ? 'أسبوع' : diffWeeks < 11 ? 'أسابيع' : 'أسبوع'}`;
                icon = '⚫';
                color = '#7c3aed';
                bgColor = '#ede9fe';
            } else if (diffMonths < 12) {
                timeText = `منذ ${diffMonths} ${diffMonths === 1 ? 'شهر' : diffMonths < 11 ? 'شهور' : 'شهر'}`;
                icon = '⚫';
                color = '#6b7280';
                bgColor = '#f3f4f6';
            } else {
                timeText = date.format('DD/MM/YYYY');
                icon = '📅';
                color = '#6b7280';
                bgColor = '#f3f4f6';
            }
            
            return {
                text: timeText,
                fullDate: date.format('DD/MM/YYYY HH:mm'),
                color: color,
                bgColor: bgColor,
                icon: icon
            };
        } catch {
            return {
                text: dateString,
                fullDate: dateString,
                color: '#6b7280',
                bgColor: '#f3f4f6',
                icon: '📅'
            };
        }
    };

    // حساب عدد الصفحات
    getTotalPages = () => {
        return Math.ceil(this.state.totalOrders / this.state.itemsPerPage);
    };

    // تغيير الصفحة
    handlePageChange = (page) => {
        if (page < 1 || page > this.getTotalPages()) return;
        const formattedDate = this.state.searchDate ? this.formatDateForAPI(this.state.searchDate) : '';
        this.fetchOrders(
            this.state.currentStatus, 
            formattedDate, 
            page,
            this.state.searchTerm,
            this.state.selectedDelayedDate
        );
    };

    // استخراج التواريخ الفريدة للفلترة (من البيانات المُرجعة من الباك إند)
    getUniqueDates = () => {
        const availableDates = this.state.availableDates || [];
        return availableDates.sort((a, b) => {
            const dateA = new Date(a.date.split('/').reverse().join('-'));
            const dateB = new Date(b.date.split('/').reverse().join('-'));
            return dateA - dateB;
        });
    };

    // حساب عدد الطلبات لكل تاريخ (من البيانات المُرجعة من الباك إند)
    getDateCount = (date) => {
        const dateInfo = this.state.availableDates?.find(d => d.date === date);
        return dateInfo ? dateInfo.count : 0;
    };

    // البحث في الطلبات (من الباك إند) مع Debounce
    handleSearch = (e) => {
        const searchTerm = e.target.value;
        this.setState({ searchTerm });
        
        // إلغاء البحث السابق إذا كان معلقاً
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        
        // تأخير البحث لمدة 500ms بعد آخر كتابة
        this.searchTimer = setTimeout(() => {
            // إعادة جلب البيانات من الباك إند مع معامل البحث
            const formattedDate = this.state.searchDate ? this.formatDateForAPI(this.state.searchDate) : '';
            this.fetchOrders(
                this.state.currentStatus, 
                formattedDate, 
                1, 
                searchTerm,
                this.state.selectedDelayedDate
            );
        }, 500);
    };

    // البحث بالتاريخ
    handleDateSearch = (e) => {
        const searchDate = e.target.value;
        this.setState({ searchDate });
        
        if (searchDate) {
            const formattedDate = this.formatDateForAPI(searchDate);
            this.fetchOrders(
                this.state.currentStatus, 
                formattedDate, 
                1,
                this.state.searchTerm,
                this.state.selectedDelayedDate
            );
        } else {
            this.fetchOrders(
                this.state.currentStatus, 
                '', 
                1,
                this.state.searchTerm,
                this.state.selectedDelayedDate
            );
        }
    };

    // فلتر تاريخ التأجيل (من الباك إند)
    handleDelayedDateFilter = (selectedDate) => {
        this.setState({ 
            selectedDelayedDate: selectedDate,
            showDateFilter: false 
        });
        
        // إعادة جلب البيانات من الباك إند مع معامل الفلتر
        const formattedDate = this.state.searchDate ? this.formatDateForAPI(this.state.searchDate) : '';
        this.fetchOrders(
            this.state.currentStatus, 
            formattedDate, 
            1, 
            this.state.searchTerm,
            selectedDate
        );
    };

    // مسح البحث بالتاريخ
    clearDateSearch = () => {
        this.setState({ searchDate: '' });
        this.fetchOrders(
            this.state.currentStatus, 
            '', 
            1,
            this.state.searchTerm,
            this.state.selectedDelayedDate
        );
    };

    // إجراء مكالمة
    handleCall = (phoneNumber) => {
        window.open(`tel:${phoneNumber}`);
    };

    // تحويل للواتساب
    handleWhatsApp = (phoneNumber) => {
        let formattedPhone = phoneNumber;
        if (phoneNumber.startsWith('07')) {
            formattedPhone = '964' + phoneNumber.substring(1);
        }
        window.open(`https://wa.me/${formattedPhone}`);
    };

    // فتح مودل المعالجة
    openModal = (orderId) => {
        this.setState({ showModal: true, selectedOrderId: orderId });
    };

    // إغلاق المودل
    closeModal = () => {
        this.setState({
            showModal: false,
            selectedStatus: '',
            postponeDate: '',
            selectedOrderId: null
        });
    };

    // تغيير الحالة المختارة
    handleStatusChange = (status) => {
        this.setState({ selectedStatus: status });
    };

    // تغيير التاريخ
    handleDateChange = (e) => {
        this.setState({ postponeDate: e.target.value });
    };

    // تحويل التاريخ من YYYY-MM-DD إلى DD/MM/YYYY
    formatDateForAPI = (dateString) => {
        try {
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch {
            return dateString;
        }
    };

    // تحويل التاريخ من DD/MM/YYYY إلى تنسيق قابل للقراءة
    parseDateFromString = (dateString) => {
        try {
            if (!dateString) return 'غير محدد';
            
            if (dateString.includes('/')) {
                const [day, month, year] = dateString.split('/');
                return `${day}/${month}/${year}`;
            }
            
            return moment(dateString).format('DD/MM/YYYY');
        } catch {
            return dateString || 'غير محدد';
        }
    };

    // إرسال التحديث
    handleSubmit = async () => {
        try {
            this.setState({ loading: true });

            const requestData = {
                id: this.state.selectedOrderId,
                status: this.state.selectedStatus
            };

            if (this.state.selectedStatus === 'مؤجل' && this.state.postponeDate) {
                requestData.Delayed = this.formatDateForAPI(this.state.postponeDate);
            }

            const response = await axios.post(`${host}users/mtab3a-orders/update/`, requestData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': cookies.get("token")
                }
            });

            alert('تم تحديث الحالة بنجاح');
            this.closeModal();

            const currentDelayParam = this.state.searchDate ? this.formatDateForAPI(this.state.searchDate) : '';
            await this.fetchOrders(
                this.state.currentStatus, 
                currentDelayParam, 
                this.state.currentPage,
                this.state.searchTerm,
                this.state.selectedDelayedDate
            );

        } catch (error) {
            console.error('تفاصيل الخطأ:', error);
            let errorMessage = 'حدث خطأ في تحديث الحالة';

            if (error.response) {
                errorMessage = `خطأ من الخادم: ${error.response.status} - ${error.response.data.message || error.response.data}`;
            } else if (error.request) {
                errorMessage = 'لم يتم الحصول على رد من الخادم. تحقق من الاتصال.';
            } else {
                errorMessage = `خطأ في الطلب: ${error.message}`;
            }

            alert(errorMessage);
        } finally {
            this.setState({ loading: false });
        }
    };

    // العودة للصفحة السابقة
    goBack = () => {
        window.history.back();
    };

    // فك ترميز النص العربي
    decodeArabicText = (text) => {
        try {
            return decodeURIComponent(text.replace(/\+/g, ' '));
        } catch {
            return text;
        }
    };

    // تنسيق التاريخ بتوقيت بغداد بدون ثواني
    formatDate = (dateString) => {
        try {
            return moment(dateString)
                .tz('Asia/Baghdad')
                .format('DD/MM/YYYY HH:mm');
        } catch {
            return dateString;
        }
    };

    // تنسيق التاريخ فقط بدون وقت
    formatDateOnly = (dateString) => {
        try {
            return moment(dateString)
                .tz('Asia/Baghdad')
                .format('DD/MM/YYYY');
        } catch {
            return dateString;
        }
    };

    render() {
        const {
            searchTerm,
            searchDate,
            filteredOrders,
            showModal,
            selectedStatus,
            postponeDate,
            loading,
            error,
            selectedDelayedDate,
            showDateFilter,
            currentPage,
            totalOrders,
            availableDates,
            isSearching
        } = this.state;

        // إضافة حالة "تم المعالجة" إلى خيارات الحالة
        const statusOptions = ['لايرد', 'كاذب', 'شركة التوصيل', 'خطأ بالتجهيز', 'مؤجل', 'تم المعالجة'];
        const totalPages = this.getTotalPages();

        const styles = {
            container: {
                minHeight: '100vh',
                backgroundColor: '#f8fafc',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                direction: 'rtl'
            },
            header: {
                backgroundColor: '#ffffff',
                padding: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                position: 'sticky',
                top: 0,
                zIndex: 10
            },
            headerContent: {
                maxWidth: '768px',
                margin: '0 auto'
            },
            topRow: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '1rem'
            },
            pageTitle: {
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#1f2937',
                textAlign: 'center',
                flex: 1,
                marginRight: '1rem'
            },
            searchRow: {
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1rem'
            },
            dateSearchRow: {
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1rem'
            },
            // إضافة ستايل للفلتر الجديد
            filterRow: {
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
            },
            searchLabel: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                whiteSpace: 'nowrap'
            },
            backButton: {
                padding: '0.75rem',
                backgroundColor: '#e2e8f0',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 0.2s',
                minWidth: '48px',
                height: '48px'
            },
            searchInput: {
                flex: 1,
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                textAlign: 'right'
            },
            dateInput: {
                flex: 1,
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                textAlign: 'right'
            },
            // ستايل فلتر التواريخ
            dateFilterButton: {
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '0.75rem 1rem',
                backgroundColor: '#ffffff',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                fontSize: '1rem',
                color: '#374151',
                transition: 'all 0.3s ease',
                minWidth: '180px',
                justifyContent: 'space-between'
            },
            dateFilterDropdown: {
                position: 'absolute',
                top: '100%',
                right: '0',
                marginTop: '8px',
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                zIndex: 1000,
                minWidth: '220px',
                overflow: 'hidden',
                maxHeight: '300px',
                overflowY: 'auto'
            },
            dateFilterOption: {
                width: '100%',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#374151',
                textAlign: 'right',
                transition: 'background-color 0.2s ease'
            },
            // ستايلات جديدة لعرض العدد الكلي والPagination
            statsRow: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '1rem',
                padding: '0.75rem',
                backgroundColor: '#f3f4f6',
                borderRadius: '0.5rem'
            },
            totalOrdersText: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151'
            },
            paginationContainer: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.5rem',
                marginTop: '2rem',
                marginBottom: '2rem'
            },
            paginationButton: {
                padding: '0.5rem 1rem',
                backgroundColor: '#ffffff',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                fontSize: '1rem',
                color: '#374151',
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem',
                transition: 'all 0.2s'
            },
            paginationButtonActive: {
                backgroundColor: '#3b82f6',
                color: '#ffffff',
                borderColor: '#3b82f6'
            },
            paginationButtonDisabled: {
                opacity: 0.5,
                cursor: 'not-allowed'
            },
            paginationInfo: {
                fontSize: '1rem',
                color: '#6b7280',
                padding: '0 1rem'
            },
            // ستايل محسن لعرض شركة التوصيل
            deliveryCompanyBox: {
                backgroundColor: '#dbeafe',
                border: '2px solid #3b82f6',
                borderRadius: '0.75rem',
                padding: '1rem',
                marginTop: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
            },
            deliveryCompanyText: {
                fontSize: '1.1rem',
                fontWeight: 'bold',
                color: '#1e40af'
            },
            content: {
                maxWidth: '768px',
                margin: '0 auto',
                padding: '1rem'
            },
            loading: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
                flexDirection: 'column',
                gap: '1rem'
            },
            error: {
                backgroundColor: '#fee2e2',
                color: '#dc2626',
                padding: '1rem',
                borderRadius: '0.5rem',
                textAlign: 'center'
            },
            orderCard: {
                backgroundColor: '#ffffff',
                borderRadius: '1rem',
                padding: '1.5rem',
                marginBottom: '1rem',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                border: '1px solid #e5e7eb'
            },
            orderHeader: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
                paddingBottom: '1rem',
                borderBottom: '1px solid #e5e7eb'
            },
            orderNumber: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#1f2937'
            },
            price: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#059669'
            },
            section: {
                marginBottom: '1.5rem'
            },
            sectionTitle: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            },
            customerInfo: {
                backgroundColor: '#f9fafb',
                padding: '1rem',
                borderRadius: '0.5rem',
                marginBottom: '1rem'
            },
            phoneButtons: {
                display: 'flex',
                gap: '0.5rem',
                marginTop: '0.5rem'
            },
            phoneButton: {
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '0.875rem',
                fontWeight: '500'
            },
            callButton: {
                backgroundColor: '#10b981',
                color: 'white'
            },
            whatsappButton: {
                backgroundColor: '#25d366',
                color: 'white'
            },
            itemsList: {
                backgroundColor: '#f0f9ff',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '2px solid #0ea5e9',
                boxShadow: '0 2px 8px rgba(14, 165, 233, 0.1)'
            },
            item: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '1rem',
                marginBottom: '0.5rem',
                backgroundColor: '#ffffff',
                borderRadius: '0.5rem',
                borderRight: '4px solid #0ea5e9',
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                fontSize: '1rem',
                fontWeight: '500'
            },
            historyItem: {
                backgroundColor: '#f3f4f6',
                padding: '1rem',
                borderRadius: '0.75rem',
                marginBottom: '0.75rem',
                borderRight: '5px solid #3b82f6',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                transition: 'all 0.3s ease'
            },
            delayedDateBox: {
                backgroundColor: '#fef3c7',
                border: '2px solid #f59e0b',
                borderRadius: '0.75rem',
                padding: '1rem',
                marginTop: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            },
            delayedDateText: {
                fontSize: '1.1rem',
                fontWeight: 'bold',
                color: '#92400e'
            },
            processButton: {
                width: '100%',
                padding: '1rem',
                backgroundColor: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '0.5rem',
                fontSize: '1.1rem',
                fontWeight: '600',
                cursor: 'pointer',
                marginTop: '1rem'
            },
            modal: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                padding: '1rem'
            },
            modalContent: {
                backgroundColor: 'white',
                borderRadius: '1rem',
                padding: '2rem',
                maxWidth: '400px',
                width: '100%',
                maxHeight: '80vh',
                overflowY: 'auto'
            },
            modalTitle: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                marginBottom: '1rem',
                textAlign: 'center'
            },
            statusOption: {
                padding: '0.75rem',
                margin: '0.25rem 0',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                textAlign: 'center',
                transition: 'all 0.2s'
            },
            statusOptionSelected: {
                backgroundColor: '#3b82f6',
                color: 'white',
                borderColor: '#3b82f6'
            },
            modalDateInput: {
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                marginTop: '1rem'
            },
            modalButtons: {
                display: 'flex',
                gap: '0.5rem',
                marginTop: '1.5rem'
            },
            modalButton: {
                flex: 1,
                padding: '0.75rem',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                fontWeight: '600'
            },
            submitButton: {
                backgroundColor: '#10b981',
                color: 'white'
            },
            cancelButton: {
                backgroundColor: '#6b7280',
                color: 'white'
            },
            noData: {
                textAlign: 'center',
                padding: '2rem',
                color: '#6b7280'
            }
        };

        if (loading) {
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <div style={styles.loading}>
                            <Loader className="animate-spin" size={40} />
                            <p>جاري تحميل الطلبات...</p>
                        </div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <div style={styles.error}>
                            {error}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <div style={styles.headerContent}>
                        <div style={styles.topRow}>
                            <button style={styles.backButton} onClick={this.goBack}>
                                <ArrowLeft size={24} />
                            </button>
                            <div style={styles.pageTitle}>الطلبات مؤجل</div>
                        </div>
                        
                        <div style={styles.searchRow}>
                            <div style={styles.searchLabel}>البحث عن طلب:</div>
                            <div style={{ flex: 1, position: 'relative' }}>
                                <input
                                    type="text"
                                    placeholder="ابحث برقم الطلب أو رقم الهاتف..."
                                    value={searchTerm}
                                    onChange={this.handleSearch}
                                    style={styles.searchInput}
                                />
                                {isSearching && (
                                    <div style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)'
                                    }}>
                                        <Loader className="animate-spin" size={20} />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* فلتر تواريخ التأجيل */}
                        <div style={styles.filterRow}>
                            <div style={styles.searchLabel}>فلترة حسب تاريخ التأجيل:</div>
                            <div style={{ position: 'relative' }}>
                                <button
                                    onClick={() => this.setState({ showDateFilter: !showDateFilter })}
                                    style={styles.dateFilterButton}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f9fafb'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#ffffff'}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Calendar size={16} />
                                        <span>
                                            {selectedDelayedDate === 'all' ? 'جميع التواريخ' : selectedDelayedDate}
                                        </span>
                                    </div>
                                    <ChevronDown 
                                        size={16}
                                        style={{ 
                                            transform: showDateFilter ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease'
                                        }}
                                    />
                                </button>

                                {showDateFilter && (
                                    <div style={styles.dateFilterDropdown}>
                                        {/* خيار جميع التواريخ */}
                                        <button
                                            onClick={() => this.handleDelayedDateFilter('all')}
                                            style={{
                                                ...styles.dateFilterOption,
                                                backgroundColor: selectedDelayedDate === 'all' ? '#f3f4f6' : 'transparent'
                                            }}
                                            onMouseEnter={(e) => {
                                                if (selectedDelayedDate !== 'all') {
                                                    e.target.style.backgroundColor = '#f9fafb';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (selectedDelayedDate !== 'all') {
                                                    e.target.style.backgroundColor = 'transparent';
                                                }
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                <Calendar size={16} color={selectedDelayedDate === 'all' ? '#2563EB' : '#6B7280'} />
                                                <span>جميع التواريخ</span>
                                            </div>
                                            <span style={{ 
                                                fontSize: '12px', 
                                                color: '#6B7280',
                                                backgroundColor: '#F3F4F6',
                                                padding: '2px 8px',
                                                borderRadius: '12px'
                                            }}>
                                                {this.state.totalOrders}
                                            </span>
                                        </button>

                                        {/* خيارات التواريخ الفردية */}
                                        {availableDates && availableDates.map((dateObj) => (
                                            <button
                                                key={dateObj.date}
                                                onClick={() => this.handleDelayedDateFilter(dateObj.date)}
                                                style={{
                                                    ...styles.dateFilterOption,
                                                    backgroundColor: selectedDelayedDate === dateObj.date ? '#f3f4f6' : 'transparent'
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (selectedDelayedDate !== dateObj.date) {
                                                        e.target.style.backgroundColor = '#f9fafb';
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (selectedDelayedDate !== dateObj.date) {
                                                        e.target.style.backgroundColor = 'transparent';
                                                    }
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <Clock size={16} color={selectedDelayedDate === dateObj.date ? '#2563EB' : '#EF4444'} />
                                                    <span>{dateObj.date}</span>
                                                </div>
                                                <span style={{ 
                                                    fontSize: '12px', 
                                                    color: '#6B7280',
                                                    backgroundColor: '#F3F4F6',
                                                    padding: '2px 8px',
                                                    borderRadius: '12px'
                                                }}>
                                                    {dateObj.count}
                                                </span>
                                            </button>
                                        ))}

                                        {(!availableDates || availableDates.length === 0) && (
                                            <div style={{
                                                padding: '16px',
                                                textAlign: 'center',
                                                color: '#6B7280',
                                                fontSize: '14px'
                                            }}>
                                                لا توجد تواريخ تأجيل
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* عرض العدد الكلي للطلبات */}
                        <div style={styles.statsRow}>
                            <div style={styles.totalOrdersText}>
                                {searchTerm || selectedDelayedDate !== 'all' ? 
                                    `نتائج البحث: ${totalOrders}` : 
                                    `إجمالي الطلبات: ${totalOrders}`
                                }
                            </div>
                            <div style={styles.totalOrdersText}>
                                الصفحة: {currentPage} من {totalPages || 1}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Content with Search Overlay */}
                <div style={styles.content}>
                    {/* عرض overlay أثناء البحث */}
                    {this.state.isSearching && filteredOrders.length > 0 && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 999,
                            flexDirection: 'column'
                        }}>
                            <Loader className="animate-spin" size={40} />
                            <p style={{ marginTop: '1rem', fontSize: '1.1rem', color: '#374151' }}>جاري البحث...</p>
                        </div>
                    )}
                    
                    {filteredOrders.length === 0 ? (
                        <div style={styles.noData}>
                            {this.state.isSearching ? (
                                <>
                                    <Loader className="animate-spin" size={30} />
                                    <p style={{ marginTop: '1rem' }}>جاري البحث...</p>
                                </>
                            ) : (
                                'لا توجد طلبات متطابقة مع البحث'
                            )}
                        </div>
                    ) : (
                        filteredOrders.map(order => (
                            <div key={order.id} style={styles.orderCard}>
                                {/* Order Header */}
                                <div style={styles.orderHeader}>
                                    <div style={styles.orderNumber}>طلب رقم: {order.id}</div>
                                    <div style={styles.price}>{order.price.toLocaleString()} د.ع</div>
                                </div>

                                {/* Customer Info */}
                                <div style={styles.section}>
                                    <div style={styles.sectionTitle}>
                                        <User size={20} />
                                        معلومات الزبون
                                    </div>
                                    <div style={styles.customerInfo}>
                                        <div><strong>الاسم:</strong> {this.decodeArabicText(order.name) || 'غير محدد'}</div>
                                        <div><strong>الهاتف:</strong> {order.phone}</div>
                                        <div style={styles.phoneButtons}>
                                            <button
                                                style={{ ...styles.phoneButton, ...styles.callButton }}
                                                onClick={() => this.handleCall(order.phone)}
                                            >
                                                <Phone size={16} />
                                                اتصال
                                            </button>
                                            <button
                                                style={{ ...styles.phoneButton, ...styles.whatsappButton }}
                                                onClick={() => this.handleWhatsApp(order.phone)}
                                            >
                                                <MessageSquare size={16} />
                                                واتساب
                                            </button>
                                        </div>
                                        <div style={{ marginTop: '0.5rem' }}>
                                            <strong>العنوان:</strong> {this.decodeArabicText(order.government)} - {this.decodeArabicText(order.city)}
                                        </div>
                                    </div>
                                </div>

                                {/* Items */}
                                <div style={styles.section}>
                                    <div style={styles.sectionTitle}>
                                        <Package size={20} />
                                        مواد الطلب
                                    </div>
                                    <div style={styles.itemsList}>
                                        {order.ordersFormItems && order.ordersFormItems.map((item, index) => (
                                            <div key={index} style={styles.item}>
                                                <span>{this.decodeArabicText(item.components.name)}</span>
                                                <span><strong>العدد: {item.count}</strong></span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Notes */}
                                {order.notes && (
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <FileText size={20} />
                                            ملاحظات
                                        </div>
                                        <div style={{ backgroundColor: '#fef3c7', padding: '0.75rem', borderRadius: '0.5rem' }}>
                                            {this.decodeArabicText(order.notes)}
                                        </div>
                                    </div>
                                )}

                                {/* History */}
                                {order.matab3alogs && order.matab3alogs.length > 0 && (
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <Clock size={20} />
                                            سجل المتابعة
                                        </div>
                                        {order.matab3alogs.map((log, index) => {
                                            const timeInfo = this.getRelativeTime(log.updatedAt);
                                            return (
                                                <div key={index} style={{
                                                    ...styles.historyItem,
                                                    borderRightColor: timeInfo.color,
                                                    backgroundColor: timeInfo.bgColor
                                                }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                        <div>
                                                            <strong style={{ fontSize: '1rem', color: '#1f2937' }}>
                                                                {this.decodeArabicText(log.user.name)}
                                                            </strong>
                                                            <span style={{ margin: '0 0.5rem', color: '#6b7280' }}>-</span>
                                                            <span style={{ color: '#374151', fontWeight: '500' }}>
                                                                {this.decodeArabicText(log.status)}
                                                            </span>
                                                        </div>
                                                        <div style={{ 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            gap: '0.25rem',
                                                            backgroundColor: 'white',
                                                            padding: '0.25rem 0.5rem',
                                                            borderRadius: '0.5rem',
                                                            border: `2px solid ${timeInfo.color}`,
                                                            marginLeft: '1rem'
                                                        }}>
                                                            <span>{timeInfo.icon}</span>
                                                            <span style={{ 
                                                                fontSize: '0.875rem', 
                                                                color: timeInfo.color, 
                                                                fontWeight: 'bold' 
                                                            }}>
                                                                {timeInfo.text}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style={{ 
                                                        fontSize: '0.75rem', 
                                                        color: '#6b7280', 
                                                        marginTop: '0.25rem',
                                                        paddingRight: '1rem' 
                                                    }}>
                                                        <Clock size={12} style={{ display: 'inline', marginLeft: '0.25rem' }} />
                                                        {timeInfo.fullDate}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}

                                {/* Order Info */}
                                <div style={styles.section}>
                                    <div style={styles.sectionTitle}>
                                        <Building2 size={20} />
                                        معلومات إضافية
                                    </div>
                                    <div style={styles.customerInfo}>
                                        <div><strong>مثبت الطلب:</strong> {this.decodeArabicText(order.user.name)}</div>
                                        
                                        {/* عرض شركة التوصيل بشكل واضح */}
                                        {order.printerOrders && order.printerOrders.length > 0 && (
                                            <div style={styles.deliveryCompanyBox}>
                                                <Truck size={24} color="#3b82f6" />
                                                <div>
                                                    <div style={styles.deliveryCompanyText}>
                                                        شركة التوصيل: {this.decodeArabicText(order.printerOrders[0].prints.name)}
                                                    </div>
                                                    <div style={{ fontSize: '0.9rem', color: '#6b7280', marginTop: '0.25rem' }}>
                                                        تاريخ الترحيل: {this.formatDateOnly(order.printerOrders[0].prints.createdAt)}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        
                                        <div style={{ marginTop: '0.75rem' }}>
                                            <strong>الحالة الحالية:</strong> {this.decodeArabicText(order.calls)}
                                        </div>
                                        
                                        {/* عرض تاريخ التأجيل إذا كان موجوداً */}
                                        {order.Delayed && (
                                            <div style={styles.delayedDateBox}>
                                                <Calendar size={20} color="#f59e0b" />
                                                <div style={styles.delayedDateText}>
                                                    تاريخ التأجيل: {this.parseDateFromString(order.Delayed)}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Process Button */}
                                <button style={styles.processButton} onClick={() => this.openModal(order.id)}>
                                    معالجة
                                </button>
                            </div>
                        ))
                    )}

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div style={styles.paginationContainer}>
                            <button
                                style={{
                                    ...styles.paginationButton,
                                    ...(currentPage === 1 ? styles.paginationButtonDisabled : {})
                                }}
                                onClick={() => this.handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                <ChevronRight size={20} />
                                السابق
                            </button>

                            {/* أرقام الصفحات */}
                            {[...Array(Math.min(5, totalPages))].map((_, index) => {
                                let pageNumber;
                                if (totalPages <= 5) {
                                    pageNumber = index + 1;
                                } else if (currentPage <= 3) {
                                    pageNumber = index + 1;
                                } else if (currentPage >= totalPages - 2) {
                                    pageNumber = totalPages - 4 + index;
                                } else {
                                    pageNumber = currentPage - 2 + index;
                                }

                                return (
                                    <button
                                        key={pageNumber}
                                        style={{
                                            ...styles.paginationButton,
                                            ...(currentPage === pageNumber ? styles.paginationButtonActive : {})
                                        }}
                                        onClick={() => this.handlePageChange(pageNumber)}
                                    >
                                        {pageNumber}
                                    </button>
                                );
                            })}

                            <button
                                style={{
                                    ...styles.paginationButton,
                                    ...(currentPage === totalPages ? styles.paginationButtonDisabled : {})
                                }}
                                onClick={() => this.handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                التالي
                                <ChevronLeft size={20} />
                            </button>
                        </div>
                    )}
                </div>

                {/* Modal */}
                {showModal && (
                    <div style={styles.modal}>
                        <div style={styles.modalContent}>
                            <div style={styles.modalTitle}>تحديث حالة الطلب</div>

                            {statusOptions.map(status => (
                                <div
                                    key={status}
                                    style={{
                                        ...styles.statusOption,
                                        ...(selectedStatus === status ? styles.statusOptionSelected : {})
                                    }}
                                    onClick={() => this.handleStatusChange(status)}
                                >
                                    {status}
                                </div>
                            ))}

                            {selectedStatus === 'مؤجل' && (
                                <input
                                    type="date"
                                    value={postponeDate}
                                    onChange={this.handleDateChange}
                                    style={styles.modalDateInput}
                                    placeholder="تاريخ التأجيل"
                                />
                            )}

                            <div style={styles.modalButtons}>
                                <button
                                    style={{ ...styles.modalButton, ...styles.submitButton }}
                                    onClick={this.handleSubmit}
                                    disabled={!selectedStatus || (selectedStatus === 'مؤجل' && !postponeDate)}
                                >
                                    تأكيد
                                </button>
                                <button
                                    style={{ ...styles.modalButton, ...styles.cancelButton }}
                                    onClick={this.closeModal}
                                >
                                    إلغاء
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default OrderDetailsPage;